export interface NotificationsResponseModel {
    IsBroadCastMessageActive: boolean;
    HasActivePromoMessage: boolean;
    TitleFR: string;
    TitleNL: string;
    BodyFR: string;
    BodyNL: string;
    ScreenType: number;
    PromoBannerDetails: PromoBannerDetails;
}

export class PromoBannerDetails {
    PromoBannerDesktopImage: string;
    PromoBannerMobileImage: string;
    PromoBannerIcon: string;
    LandingPageLinkFR: string;
    LandingPageLinkNL: string;
}

export enum BroadcastScreenType {
    Dashboard = 'dashboard',
    Recap = 'recap',
    ContractDetails = 'contract/plan',
    Profile = 'profile'
}

export const ScreenTypeMap: Record<BroadcastScreenType, string[]> = {
    [BroadcastScreenType.Dashboard]: ['/dashboard'],
    [BroadcastScreenType.Recap]: ['/recap'],
    [BroadcastScreenType.ContractDetails]: ['/contract/plan'],
    [BroadcastScreenType.Profile]: ['/profile']

}

export enum ScreenType {
    Both = 0,
    CZ = 1,
    Recap = 2
}